<template>
  <v-col cols="12" sm="12" md="8" class="d-flex">
    <v-card class="elevation-1 flex-grow-1">
      <v-toolbar
        color="white"
        flat
        :class="{ 'cta-blurred-card': isCallToActionWidget }"
      >
        <v-toolbar-title class="text-md-subtitle-1">
          <span>Leads Sent by Source</span>
          <v-btn
            icon="fa-regular fa-circle-info"
            variant="text"
            aria-label="info"
            color="btncolor"
            @click="showToolTip"
          >
          </v-btn>
        </v-toolbar-title>
      </v-toolbar>
      <v-container
        class="pa-0"
        :class="{
          'cta-blurred-card': isCallToActionWidget,
          'leads-by-source-container-min-height': !isCallToActionWidget,
        }"
      >
        <v-row v-if="loading" align="center" justify="center">
          <v-col class="pt-12 mt-12">
            <div class="text-center dashboard-widget-progress-container">
              <v-progress-circular
                :size="75"
                :width="8"
                class="my-auto"
                color="primary"
                indeterminate
              />
            </div>
          </v-col>
        </v-row>
        <v-row v-else class="pt-0">
          <v-col v-if="leads.length === 0" class="mt-12 text-center">
            <v-icon size="18">fa-solid fa-chart-line</v-icon> No lead reports
            available
          </v-col>
          <v-col v-else>
            <v-data-table-server
              class="elevation-0 leads-by-source-table"
              :headers="headers"
              :items="leads"
              :items-length="totalLeads"
              :loading="loading"
              :mobile="false"
              dense
            >
              <!-- remove bottom pagination -->
              <template #bottom></template>
            </v-data-table-server>
          </v-col>
        </v-row>
      </v-container>
      <!--      <v-window v-model="step">-->
      <!--        &lt;!&ndash; Sources List Window &ndash;&gt;-->
      <!--        <v-window-item :value="1">-->
      <!--          <v-container-->
      <!--            class="pa-0"-->
      <!--            fluid-->
      <!--            :class="{-->
      <!--              'cta-blurred-card': isCallToActionWidget,-->
      <!--              'leads-by-source-container-min-height': !isCallToActionWidget,-->
      <!--            }"-->
      <!--          >-->
      <!--            <v-row-->
      <!--              v-if="loading && !isCallToActionWidget"-->
      <!--              align="center"-->
      <!--              justify="center"-->
      <!--            >-->
      <!--              <v-col class="pt-0 text-center">-->
      <!--                <div class="dashboard-widget-progress-container">-->
      <!--                  <v-progress-circular-->
      <!--                    :size="75"-->
      <!--                    :width="8"-->
      <!--                    class="my-auto"-->
      <!--                    color="primary"-->
      <!--                    indeterminate-->
      <!--                  />-->
      <!--                </div>-->
      <!--              </v-col>-->
      <!--            </v-row>-->
      <!--            <v-row v-if="!loading && sources.length === 0">-->
      <!--              <v-col>-->
      <!--                <v-sheet-->
      <!--                  class="mt-12 pt-12"-->
      <!--                  color="white"-->
      <!--                  height="400"-->
      <!--                  item-->
      <!--                  width="100%"-->
      <!--                >-->
      <!--                  <v-row align="center" justify="center" wrap fill-height>-->
      <!--                    <v-avatar color="primary" size="120">-->
      <!--                      <v-avatar color="white" size="110">-->
      <!--                        <v-icon color="primary" size="60"-->
      <!--                          >far fa-window-restore</v-icon-->
      <!--                        >-->
      <!--                      </v-avatar>-->
      <!--                    </v-avatar>-->
      <!--                  </v-row>-->
      <!--                  <v-row align="center" justify="center">-->
      <!--                    <span class="font-weight-light body-1 mt-4">-->
      <!--                      No sources have reported any leads.-->
      <!--                    </span>-->
      <!--                  </v-row>-->
      <!--                </v-sheet>-->
      <!--              </v-col>-->
      <!--            </v-row>-->
      <!--            <v-list v-else class="mb-2" dense>-->
      <!--              <v-list-item-->
      <!--                v-for="src in sources"-->
      <!--                :key="src.supplierName"-->
      <!--                @click="sourceClick(src)"-->
      <!--              >-->
      <!--                <v-row>-->
      <!--                  <v-col class="align-self-center">-->
      <!--                    <v-list-item-title-->
      <!--                      v-text="src.supplierName"-->
      <!--                      class="font-weight-light align-self-center leads-by-source-text pl-2"-->
      <!--                    />-->
      <!--                  </v-col>-->

      <!--                  <v-col>-->
      <!--                    <v-list-item-action class="text-right justify-end">-->
      <!--                      <span-->
      <!--                        class="pr-4 funnel-count text-h6 leads-by-source-data"-->
      <!--                      >-->
      <!--                        {{ src.leadSuppliedCount }}-->
      <!--                      </span>-->
      <!--                    </v-list-item-action>-->
      <!--                  </v-col>-->
      <!--                </v-row>-->
      <!--              </v-list-item>-->
      <!--            </v-list>-->
      <!--          </v-container>-->
      <!--        </v-window-item>-->
      <!--        &lt;!&ndash; Source Summary Window &ndash;&gt;-->
      <!--        <v-window-item :value="2">-->
      <!--          <v-container class="pa-0" fluid>-->
      <!--            <v-row-->
      <!--              v-if="summaryLoading && !isCallToActionWidget"-->
      <!--              align="center"-->
      <!--              justify="center"-->
      <!--            >-->
      <!--              <v-col class="pt-0">-->
      <!--                <div class="dashboard-widget-progress-container">-->
      <!--                  <v-progress-circular-->
      <!--                    :size="75"-->
      <!--                    :width="8"-->
      <!--                    class="my-auto"-->
      <!--                    color="primary"-->
      <!--                    indeterminate-->
      <!--                  />-->
      <!--                </div>-->
      <!--              </v-col>-->
      <!--            </v-row>-->
      <!--            <v-list-->
      <!--              v-else-->
      <!--              class="mb-2"-->
      <!--              :class="{-->
      <!--                'cta-blurred-card': isCallToActionWidget,-->
      <!--                'leads-by-source-max-width': !isCallToActionWidget,-->
      <!--              }"-->
      <!--            >-->
      <!--              <v-list-item>-->
      <!--                <v-row class="px-0">-->
      <!--                  <v-col cols="2" class="align-self-center">-->
      <!--                    <v-avatar>-->
      <!--                      <v-btn-->
      <!--                        icon="fas fa-chevron-left"-->
      <!--                        color="gray"-->
      <!--                        size="large"-->
      <!--                        @click="backToAll"-->
      <!--                        variant="text"-->
      <!--                      >-->
      <!--                      </v-btn>-->
      <!--                    </v-avatar>-->
      <!--                  </v-col>-->

      <!--                  <v-col class="align-self-center">-->
      <!--                    <v-list-item-title class="body-1">-->
      <!--                      View All Sources-->
      <!--                    </v-list-item-title>-->
      <!--                  </v-col>-->
      <!--                </v-row>-->
      <!--              </v-list-item>-->
      <!--              <v-list-item-->
      <!--                v-for="s in summary"-->
      <!--                :key="s.status"-->
      <!--                @click="statusClick(s)"-->
      <!--              >-->
      <!--                <v-row>-->
      <!--                  <v-col>-->
      <!--                    <v-list-item-title-->
      <!--                      v-text="s.title"-->
      <!--                      class="font-weight-light leads-by-source-text pl-2"-->
      <!--                    />-->
      <!--                  </v-col>-->
      <!--                  <v-col>-->
      <!--                    <v-list-item-action class="text-right justify-end">-->
      <!--                      <span-->
      <!--                        class="pr-4 funnel-count text-h6 leads-by-source-data"-->
      <!--                      >-->
      <!--                        {{ s.count }}-->
      <!--                      </span>-->
      <!--                    </v-list-item-action>-->
      <!--                  </v-col>-->
      <!--                </v-row>-->
      <!--              </v-list-item>-->
      <!--            </v-list>-->
      <!--          </v-container>-->
      <!--        </v-window-item>-->
      <!--      </v-window>-->

      <overview-call-to-action-widget
        v-if="isCallToActionWidget"
        :cta-text="ctaText"
        :title="dialogTitle"
        :description="dialogDescription"
        class="call-to-action-widget"
      />
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters } from "vuex";
import api from "@/services/api.js";
import OverviewCallToActionWidget from "@/components/console/dashboard/OverviewCallToActionWidget";
import C from "@/utils/constants";
import useFormatters from "@/mixins/formatters";

export default {
  name: "console-overview-leads-by-source",
  components: { OverviewCallToActionWidget },
  props: {
    isCallToActionWidget: {
      type: Boolean,
      default: false,
    },
  },
  watch: {},
  data() {
    return {
      dialogTitle: "",
      dialogDescription: "",
      ctaText: "",
      scrollableList: true,
      loading: false,
      summaryLoading: false,
      step: 1,
      source: null,
      sources: [],
      summary: [],
      toolTip: null,
      toolTipDialog: false,
      leads: [],
      totalLeads: 0,
      headers: [
        {
          title: "",
          value: "supplierName",
          key: "supplierName",
          sortable: false,
          align: "start",
          width: "15%",
        },
        {
          title: "Total Leads",
          value: "leadSuppliedCount",
          key: "leadSuppliedCount",
          sortable: false,
          align: "start",
          width: "12%",
        },
        {
          title: "Referral Rate",
          value: "assignedReferralRate",
          key: "assignedReferralRate",
          sortable: false,
          align: "start",
          width: "12%",
        },
        {
          title: "Close Rate",
          value: "closedReferralRate",
          key: "closedReferralRate",
          sortable: false,
          align: "start",
          width: "12%",
        },
        {
          title: "Referrals Assigned",
          value: "assignedReferralCount",
          key: "assignedReferralCount",
          sortable: false,
          align: "start",
          width: "16%",
        },
        {
          title: "Closed",
          value: "closedReferralCount",
          key: "closedReferralCount",
          sortable: false,
          align: "start",
          width: "12%",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("user", ["myBrokerage"]),
    ...mapGetters("auth", ["impBrokerage"]),
  },
  methods: {
    ...useFormatters(),
    async loadSources() {
      this.loading = true;

      let brokerage = this.myBrokerage;
      if (this.impBrokerage !== null) {
        brokerage = this.impBrokerage;
      }

      if (brokerage && brokerage.id) {
        try {
          let { data } = await api.interviews.getLeadsBySource(brokerage.id);

          data.forEach((item) => {
            item.assignedReferralRate = `${item.assignedReferralRate}%`;
            item.closedReferralRate = `${item.closedReferralRate}%`;
          });
          this.leads = data;
        } catch (e) {
          console.error(e);
        } finally {
          this.loading = false;
        }
      } else {
        this.loading = false;
      }

      // setTimeout(() => {
      //   this.leads = [
      //     {
      //       url: "example.com",
      //       total_leads: "100",
      //       referral_rate: "40.00%",
      //       close_rate: "4.00%",
      //       assigned_agents: "40",
      //       closed: "4",
      //     },
      //     {
      //       url: "homes.com",
      //       total_leads: "200",
      //       referral_rate: "37.5%",
      //       close_rate: "2.50%",
      //       assigned_agents: "75",
      //       closed: "5",
      //     },
      //     {
      //       url: "realtor.com",
      //       total_leads: "250",
      //       referral_rate: "32.00%",
      //       close_rate: "1.60%",
      //       assigned_agents: "80",
      //       closed: "4",
      //     },
      //   ];
      //
      //   this.loading = false;
      // }, 2000);

      // let brokerage = this.myBrokerage;
      // if (this.impBrokerage !== null) {
      //   brokerage = this.impBrokerage;
      // }
      //
      // if (brokerage && brokerage.id) {
      //   try {
      // let { data } = await api.interviews.getLeadsBySource(
      //   // "e363a29c-66af-4ec7-a399-03b638c9b4b6"
      //   brokerage.id,
      // );
      //     this.sources = data;
      //   } catch (e) {
      //     console.log(e);
      //   } finally {
      //     this.loading = false;
      //   }
      // } else {
      //   this.loading = false;
      // }
    },
    async loadStats() {
      // this.summaryLoading = true;
      // this.summary = [];
      // let brokerage = this.myBrokerage;
      // if (this.impBrokerage !== null) {
      //   brokerage = this.impBrokerage;
      // }
      //
      // if (brokerage && brokerage.id) {
      //   try {
      //     let params = {
      //       source: this.source.supplierName,
      //     };
      //
      //     let { data } = await api.interviews.getOpportunityStatusStats(
      //       brokerage.id,
      //       params,
      //     );
      //     this.summary = data
      //       .map((d) => {
      //         return { ...d, title: this.prettyPrintEnum(d.status) };
      //       })
      //       .filter((s) => {
      //         return s.status !== "ASSIGNED_TO_AGENT";
      //       });
      //
      //     console.log(this.summary);
      //   } catch (e) {
      //     console.log(e);
      //   } finally {
      //     await this.loadReferralStageStats(brokerage.id);
      //   }
      // } else {
      //   this.summaryLoading = false;
      // }
    },
    // async loadReferralStageStats(brokerageId) {
    //   // try {
    //   //   let { data } = await api.interviews.getReferralStageStats(
    //   //     brokerageId,
    //   //     this.source.supplierName,
    //   //   );
    //   //   console.log(data);
    //   //   let referralStageStats = data.map((d) => {
    //   //     return { ...d, title: this.prettyPrintEnum(d.referralStage) };
    //   //   });
    //   //
    //   //   this.summary.push.apply(this.summary, referralStageStats);
    //   // } catch (e) {
    //   //   console.log(e);
    //   // } finally {
    //   //   this.summaryLoading = false;
    //   // }
    // },
    // sourceClick(source) {
    //   // this.source = source;
    //   // this.summaryLoading = true;
    //   // this.step = 2;
    //   // this.loadStats();
    // },
    // statusClick(status) {
    //   // if (status.referralStage) {
    //   //   console.log("Push it for status.referralStage");
    //   //   this.$router.push({
    //   //     name: "my-referrals",
    //   //     query: {
    //   //       s: status.referralStage,
    //   //     },
    //   //   });
    //   // } else if (status.status) {
    //   //   console.log("Push it for status.status");
    //   //
    //   //   this.$router.push({
    //   //     name: "my-leads",
    //   //     query: {
    //   //       status: status.status,
    //   //       supplierName: this.source.supplierName,
    //   //     },
    //   //   });
    //   // }
    // },
    // backToAll() {
    //   // this.source = null;
    //   // this.summary = [];
    //   // this.step = 1;
    // },
    showToolTip() {
      this.$emit("toolTip", "OverviewLeadsBySourceToolTip");
    },
  },
  mounted() {
    // this.step = 1;
    if (this.isCallToActionWidget) {
      this.sources = [...C.LEADS_BY_SOURCE_DUMMY_DATA];
      this.ctaText = C.LEADS_BY_SOURCE_CTA_TEXT;
      this.dialogTitle = "Leads By Source";
      this.dialogDescription = C.LEADS_BY_SOURCE_CTA_DESCRIPTION;
      this.summary = [];
    } else {
      this.loadSources();
    }
  },
};
</script>

<style scoped>
.call-to-action-widget {
  width: 100%;
  position: absolute;
  bottom: 0;
}
.cta-blurred-card {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  filter: blur(4px);
  opacity: 0.7;
  pointer-events: none;
  max-height: unset;
}
.leads-by-source-container-min-height {
  min-height: 500px;
}
.leads-by-source-max-width {
  max-height: 500px;
  overflow-y: auto;
}
.v-list__item__avatar {
  min-width: unset !important;
}

.leads-by-source-text {
  font-size: 14px !important;
}
.leads-by-source-data {
  color: black;
}

/*.leads-by-source-table-container {*/
/*  min-height: 420px;*/
/*}*/

.leads-by-source-table >>> table {
  width: 100%;
  /*min-height: 420px;*/
  table-layout: fixed;
}
.leads-by-source-table >>> table thead tr th {
  border-bottom: none !important;
  border-top: none !important;
  border-color: #ffffff !important;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}
.leads-by-source-table >>> .th-10 {
  width: 10%;
}
.leads-by-source-table >>> .th-25 {
  width: 25%;
}

/* set the header to 100% once in the sm and below breakpoints */
@media only screen and (max-width: 959px) {
  .leads-by-source-table >>> .name-th {
    width: 100%;
  }
}

.leads-by-source-table >>> th.active {
  color: #4a90e2 !important;
  font-weight: 600 !important;
}

.leads-by-source-table >>> table tbody tr {
  font-size: 14px !important;
}
.leads-by-source-table >>> table tbody tr td {
  border-bottom: none !important;
  border-top: none !important;
  border-color: #ffffff !important;
  font-size: 14px !important;
  height: 42px !important;
}

/*See ConsoleOverview for non-scoped classes*/
</style>
